import Fetch from "utils/fetch";
import { generateQueryParams } from "utils/custom-functions";

export const getData = (filter) =>
  Fetch.get(`/delivery-schedules:with-load-compositions?${generateQueryParams(filter)}`).then(({ data }) => data);

export const getPedidos = ({ IdUnidadeNegocio, IdFornecedor, IdComposicao, idUsuario }) =>
  Fetch.get(`/pedido/listapedidosmesmocontratoporunidadenegocio/${IdUnidadeNegocio}/${idUsuario}/${IdFornecedor}/${0}/${IdComposicao}`)
    .then((response) => response.data);
